var _class, _descriptor, _descriptor2, _CategoryRow;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { cached } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { inject as service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { isEmpty, isNone } from "@ember/utils";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import concatClass from "discourse/helpers/concat-class";
import dirSpan from "discourse/helpers/dir-span";
import Category from "discourse/models/category";
let CategoryRow = (_class = (_CategoryRow = class CategoryRow extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
  }
  get isNone() {
    return this.rowValue === this.args.selectKit?.noneItem;
  }
  get highlightedValue() {
    return this.args.selectKit.get("highlighted.id");
  }
  get isHighlighted() {
    return this.rowValue === this.highlightedValue;
  }
  get isSelected() {
    return this.rowValue === this.args.value;
  }
  get hideParentCategory() {
    return this.args.selectKit.options.hideParentCategory;
  }
  get categoryLink() {
    return this.args.selectKit.options.categoryLink;
  }
  get countSubcategories() {
    return this.args.selectKit.options.countSubcategories;
  }
  get allowUncategorizedTopics() {
    return this.siteSettings.hideParentCategory;
  }
  get allowUncategorized() {
    return this.args.selectKit.options.allowUncategorized;
  }
  get rowName() {
    return this.args.item?.name;
  }
  get rowValue() {
    return this.args.item?.id;
  }
  get guid() {
    return guidFor(this.args.item);
  }
  get label() {
    return this.args.item?.name;
  }
  get displayCategoryDescription() {
    const option1 = this.args.selectKit.options.displayCategoryDescription;
    if (isNone(option1)) {
      return true;
    }
    return option1;
  }
  get title() {
    if (this.category) {
      return this.categoryName;
    }
  }
  get categoryName() {
    return this.category.name;
  }
  get categoryDescriptionText() {
    return this.category.description_text;
  }
  get category() {
    if (isEmpty(this.rowValue)) {
      const uncategorized1 = Category.findUncategorized();
      if (uncategorized1 && uncategorized1.name === this.rowName) {
        return uncategorized1;
      }
    } else {
      return Category.findById(parseInt(this.rowValue, 10));
    }
  }
  get badgeForCategory() {
    return htmlSafe(categoryBadgeHTML(this.category, {
      link: this.categoryLink,
      allowUncategorized: this.allowUncategorizedTopics || this.allowUncategorized,
      hideParent: !!this.parentCategory,
      topicCount: this.topicCount
    }));
  }
  get badgeForParentCategory() {
    return htmlSafe(categoryBadgeHTML(this.parentCategory, {
      link: this.categoryLink,
      allowUncategorized: this.allowUncategorizedTopics || this.allowUncategorized,
      recursive: true
    }));
  }
  get parentCategory() {
    return Category.findById(this.parentCategoryId);
  }
  get hasParentCategory() {
    return this.parentCategoryId;
  }
  get parentCategoryId() {
    return this.category?.parent_category_id;
  }
  get categoryTotalTopicCount() {
    return this.category?.totalTopicCount;
  }
  get categoryTopicCount() {
    return this.category?.topic_count;
  }
  get topicCount() {
    return this.countSubcategories ? this.categoryTotalTopicCount : this.categoryTopicCount;
  }
  get shouldDisplayDescription() {
    return this.displayCategoryDescription && this.categoryDescriptionText && this.categoryDescriptionText !== "null";
  }
  get descriptionText() {
    if (this.categoryDescriptionText) {
      return this._formatDescription(this.categoryDescriptionText);
    }
  }
  handleMouseEnter() {
    if (this.site.mobileView) {
      return;
    }
    if (!this.isDestroying || !this.isDestroyed) {
      this.args.selectKit.onHover(this.rowValue, this.args.item);
    }
    return false;
  }
  handleClick(event1) {
    event1.preventDefault();
    event1.stopPropagation();
    this.args.selectKit.select(this.rowValue, this.args.item);
    return false;
  }
  handleMouseDown(event1) {
    if (this.args.selectKit.options.preventHeaderFocus) {
      event1.preventDefault();
    }
  }
  handleFocusIn(event1) {
    event1.stopImmediatePropagation();
  }
  handleKeyDown(event1) {
    if (this.args.selectKit.isExpanded) {
      if (event1.key === "Backspace") {
        if (this.args.selectKit.isFilterExpanded) {
          this.args.selectKit.set("filter", this.args.selectKit.filter.slice(0, -1));
          this.args.selectKit.triggerSearch();
          this.args.selectKit.focusFilter();
          event1.preventDefault();
          event1.stopPropagation();
        }
      } else if (event1.key === "ArrowUp") {
        this.args.selectKit.highlightPrevious();
        event1.preventDefault();
      } else if (event1.key === "ArrowDown") {
        this.args.selectKit.highlightNext();
        event1.preventDefault();
      } else if (event1.key === "Enter") {
        event1.stopImmediatePropagation();
        this.args.selectKit.select(this.args.selectKit.highlighted.id, this.args.selectKit.highlighted);
        event1.preventDefault();
      } else if (event1.key === "Escape") {
        this.args.selectKit.close(event1);
        this.args.selectKit.headerElement().focus();
        event1.preventDefault();
        event1.stopPropagation();
      } else {
        if (this._isValidInput(event1.key)) {
          this.args.selectKit.set("filter", event1.key);
          this.args.selectKit.triggerSearch();
          this.args.selectKit.focusFilter();
          event1.preventDefault();
          event1.stopPropagation();
        }
      }
    }
  }
  _formatDescription(description1) {
    const limit1 = 200;
    return `${description1.slice(0, limit1)}${description1.length > limit1 ? "&hellip;" : ""}`;
  }
  _isValidInput(eventKey1) {
    // relying on passing the event to the input is risky as it could not work
    // dispatching the event won't work as the event won't be trusted
    // safest solution is to filter event and prefill filter with it
    const nonInputKeysRegex1 = /F\d+|Arrow.+|Meta|Alt|Control|Shift|Delete|Enter|Escape|Tab|Space|Insert|Backspace/;
    return !nonInputKeysRegex1.test(eventKey1);
  }
}, template(`
    {{! template-lint-disable no-pointer-down-event-binding }}
    <div
      class={{concatClass
        "category-row"
        "select-kit-row"
        (if this.isSelected "is-selected")
        (if this.isHighlighted "is-highlighted")
        (if this.isNone "is-none")
      }}
      role="menuitemradio"
      data-index={{@index}}
      data-name={{this.rowName}}
      data-value={{this.rowValue}}
      data-title={{this.title}}
      title={{this.title}}
      data-guid={{this.guid}}
      {{on "focusin" this.handleFocusIn}}
      {{on "mousedown" this.handleMouseDown}}
      {{on "mouseenter" this.handleMouseEnter passive=true}}
      {{on "click" this.handleClick}}
      {{on "keydown" this.handleKeyDown}}
      aria-checked={{this.isSelected}}
      tabindex="0"
    >

      {{#if this.category}}
        <div class="category-status" aria-hidden="true">
          {{#if this.hasParentCategory}}
            {{#unless this.hideParentCategory}}
              {{this.badgeForParentCategory}}
            {{/unless}}
          {{/if}}
          {{this.badgeForCategory}}
        </div>

        {{#if this.shouldDisplayDescription}}
          <div class="category-desc" aria-hidden="true">
            {{dirSpan this.descriptionText htmlSafe="true"}}
          </div>
        {{/if}}
      {{else}}
        {{htmlSafe this.label}}
      {{/if}}
    </div>
  `, {
  component: _CategoryRow,
  eval() {
    return eval(arguments[0]);
  }
}), _CategoryRow), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "category", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "category"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "badgeForCategory", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "badgeForCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "badgeForParentCategory", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "badgeForParentCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "descriptionText", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "descriptionText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocusIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocusIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype)), _class);
export { CategoryRow as default };